import {Link} from "react-router-dom";

export const PoolCard = ({pool}) => {
    const {id, name, category, sizes, colors} = pool
    const placeholder = 'assets/pools/noimage.svg'
    return (
        <div className="pool__card">
            <img src={colors[0].picture ? colors[0].picture : placeholder} alt={name} />
            <small>{category}</small>
            <h3>{name}</h3>
            <small>{sizes.length} tamaños disponibles</small>
            <Link to={'./' + id} className={'button'}>Ver más</Link>
        </div>
    )
}